import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import {
  Form,
  Input,
  Select,
  Modal,
  Typography,
  DatePicker,
  Button,
  Checkbox,
  notification,
} from "antd";
import SuppliersApi from "../../Apis/SuppliersApi";
import TextArea from "antd/es/input/TextArea";
import GoodInwardApi from "../../Apis/GoodInwardApi";
import ProductApi from "../../Apis/ProductApi";
import dayjs from "dayjs";
import moment from "moment";
import { ReloadOutlined, SyncOutlined } from "@ant-design/icons";
import DepartmentModel from "../../DropDowns/DepartmentModel";

const { Title } = Typography;

function EditGoodInward({ visible, onClose, GoodInward }) {
  const [form] = Form.useForm();
  const [Suppliers, setSuppliers] = React.useState([]);
  const [VanCondotion, Set_VanCondotion] = useState(null);
  const [CorrectiveAction, Set_CorrectiveAction] = useState(null);
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  
  const getSupplier = useCallback(() => {
    SuppliersApi.Listsuppliers()
      .then((response) => {
        setSuppliers(response?.payloadDto);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  
  const [Products, setProducts] = React.useState([]);
  const getProducts = useCallback(() => {
    ProductApi.Listproducts()
      .then((response) => {
        setProducts(response?.payloadDto);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    getSupplier();
    getProducts();
  }, [getSupplier, getProducts]);

  // Set form values when GoodInward data changes
  useEffect(() => {
    if (GoodInward) {
      form.setFieldsValue({
        generatedNumber: GoodInward?.generatedNumber,
        deliveryDocketNumber: GoodInward?.deliveryDocketNumber,
        temperature: GoodInward?.temperature,
        supplierId: GoodInward?.supplierDTO?.id,
        productId: GoodInward?.productId,
        institutionId: GoodInward?.institutionId,
        temperatureRecheck: GoodInward?.temperatureRecheck,
        remark: GoodInward?.remark,
      });
      
      // Set van condition if it exists
      if (GoodInward?.vanCondition) {
        Set_VanCondotion(GoodInward.vanCondition);
      }
      if (GoodInward?.correctiveAction) {
        Set_CorrectiveAction(GoodInward.correctiveAction);
      }
    }
  }, [GoodInward, form]);

  const handleSubmit = (data) => {
    const SelectDate = moment(data.createDate).format("DD/MM/YYYY");
    const unixTimestamp = convertToUnixTimestamp(SelectDate);
    const productDetails = Products.find((item) => item.id === data.productId);

    let formData = JSON.stringify({
      deliveryDocketNumber: data.deliveryDocketNumber,
      temperature: data.temperature,
      vanCondition: VanCondotion ? VanCondotion : GoodInward?.vanCondition,
      correctiveAction: CorrectiveAction
        ? CorrectiveAction
        : GoodInward?.correctiveAction,
      goodInwardCreateDate: unixTimestamp,
      remark: data.remark,
      temperatureRecheck: data.temperatureRecheck,
      tenantDTO: {
        id: decodedToken?.tenantId,
        tenantApiKey: decodedToken?.tenantApiKey,
      },
      supplierDTO: {
        id: data.supplierId,
      },
      institutionDTO: {
        id: data.institutionId,
      },
      productDTO: {
        id: productDetails?.id,
        institutionDTO: {
          id: productDetails?.institutionDTO?.id,
        },
        subTenantDTO: {
          id: productDetails?.institutionDTO?.id,
        },
      },
    });

    GoodInwardApi.PutGoodInward(GoodInward?.id, formData)
      .then((response) => {
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Updated</span>,
          description: "Updated Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        setTimeout(() => {
          window.location.reload();
        }, 500);
      })
      .catch((err) => {
        console.log(err);
        if (err.apiError?.status) {
          notification.open({
            message: (
              <span style={{ fontWeight: "bold" }}>{err.apiError.status}</span>
            ),
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };

  function convertToUnixTimestamp(dateString) {
    const parts = dateString.split("/");
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1;
    const year = parseInt(parts[2], 10);
    const unixTimestamp = Date.UTC(year, month, day);
    return unixTimestamp;
  }

  const [isTemperatureClicked, setIsTemperatureClicked] = useState(false);
  const [IsReloadproductClicked, setIsReloadproductClicked] = useState(false);
  const [IsReloadSupplierClicked, setIsReloadSupplierClicked] = useState(false);

  const handleTemperatureClick = () => {
    setIsTemperatureClicked(!isTemperatureClicked);
  };

  const handleReloadSupplierClick = () => {
    getSupplier();
    setIsReloadSupplierClicked(true);
    setTimeout(() => {
      setIsReloadSupplierClicked(false);
    }, 1000);
  };

  const handleReloadproductClick = () => {
    getProducts();
    setIsReloadproductClicked(true);
    setTimeout(() => {
      setIsReloadproductClicked(false);
    }, 1000);
  };

  return (
    <>
      <Modal
        footer={[]}
        width={700}
        visible={visible}
        onCancel={onClose}
        onOk={onClose}
        maskClosable={false}
      >
        <Title level={4} className="text-center Primary-Font mb-4 pb-3">
          Edit Goods Inward
        </Title>
        <Form
          form={form}
          name="nest-messages"
          layout="horizontal"
          labelCol={{
            span: 8,
          }}
          wrapperCol={{
            span: 16,
          }}
          className="FormClass IndividualProduct-Model"
          onFinish={handleSubmit}
        >
          {/* G.No - Read Only */}
          <Form.Item
            name="generatedNumber"
            label="G.No :"
            className="text-lable"
            rules={[
              {
                required: true,
                message: "Please enter Generated Number.",
              },
            ]}
          >
            <Input
              type="text"
              disabled
              placeholder="Generated Number"
              className="control-input"
            />
          </Form.Item>

          {/* Date - Read Only */}
          <Form.Item
            name="createDate"
            label="Date :"
            initialValue={GoodInward?.goodInwardCreateDate ? dayjs(parseInt(GoodInward.goodInwardCreateDate)) : null}
            className="text-lable"
            rules={[
              {
                required: true,
                message: "Please select Date.",
              },
            ]}
          >
            <DatePicker
              format={"DD/MM/YYYY"}
              className="form-control control-input"
              disabled
              style={{ width: '100%' }}
            />
          </Form.Item>

          {/* Time - Read Only */}
          <Form.Item
            label="Time :"
            className="text-lable"
          >
            <Input
              type="text"
              disabled
              value={GoodInward?.createdDate ? new Date(GoodInward.createdDate).toLocaleTimeString() : ""}
              className="control-input"
            />
          </Form.Item>

          {/* Supplier - Read Only */}
          <Form.Item
            name="supplierId"
            label="Supplier :"
            className="text-lable"
            rules={[
              {
                required: true,
                message: "Please Select Supplier.",
              },
            ]}
          >
            <Select
              className="control-Select mb-1"
              placeholder="Select Supplier Name"
              disabled
              value={GoodInward?.supplierDTO?.id}
            >
              {Suppliers && Suppliers.length > 0 ? (
                Suppliers.map((option) => (
                  <Select.Option key={option.id} value={option.id}>
                    {option.supplierName}
                  </Select.Option>
                ))
              ) : (
                <Select.Option value={GoodInward?.supplierDTO?.id}>
                  {GoodInward?.supplierDTO?.supplierName || "No supplier found"}
                </Select.Option>
              )}
            </Select>
          </Form.Item>

          {/* D.D.No - Editable */}
          <Form.Item
            style={{ marginTop: 8 }}
            name="deliveryDocketNumber"
            label="D.D.No :"
            className="text-lable"
            rules={[
              {
                required: true,
                message: "Please enter Delivery Docket Number",
              },
            ]}
          >
            <Input
              type="text"
              disabled
              placeholder="Delivery Docket Number"
              className="control-input"
            />
          </Form.Item>

          {/* Van Condition - Editable */}
          <Form.Item
            style={{ marginBottom: 8 }}
            label="Van Condition :"
            className="text-lable"
            rules={[
              {
                required: true,
                message: "Please select Van Condition",
              },
            ]}
          >
            <div className="GoodsInward-Checkbox" style={{ display: 'flex', gap: '20px', paddingTop: '0px' }}>
              <Checkbox
                checked={VanCondotion === "Accept"}
                onChange={() => Set_VanCondotion("Accept")}
              >
                Accept
              </Checkbox>
              <Checkbox
                checked={VanCondotion === "Decline"}
                onChange={() => Set_VanCondotion("Decline")}
              >
                Not Accept
              </Checkbox>
            </div>
          </Form.Item>

          {/* Remark - Shows when Van Condition is Decline */}
          {VanCondotion === "Decline" && (
            <Form.Item
              name="remark"
              label="Remark :"
              className="text-lable"
              rules={[
                {
                  required: VanCondotion === "Decline",
                  message: "Please enter remark",
                },
              ]}
            >
              <TextArea
                className="form-control control-input"
                rows={3}
                style={{ resize: "none" }}
                placeholder="Enter remark"
              />
            </Form.Item>
          )}

          {/* Temperature - Editable */}
          <div style={{maxWidth: '100%', display: 'flex', alignItems: 'center', gap: '10px', paddingLeft: '40px' }}>
            <Form.Item
              name="temperature"
              label="Temperature :"
              className="text-lable"
              rules={[
                {
                  required: true,
                  message: "Please enter Temperature",
                },
              ]}
              style={{ flex: 1, marginBottom: 16 }}
            >
              <Input
                type="text"
                placeholder="Temperature"
                className="control-input"
                style={{ width: '100%' }}
              />
            </Form.Item>
            <div style={{ marginTop: '2px', whiteSpace: 'nowrap' }}>
              <span
                style={{ 
                  cursor: "pointer", 
                  color: "#0b5ed7",
                  fontSize: "14px",
                  fontWeight: "500"
                }}
                onClick={handleTemperatureClick}
              >
                Re-Check
              </span>
            </div>
          </div>

          {/* Recheck Temp - Editable when clicked */}
          {isTemperatureClicked && (
            <Form.Item
              name="temperatureRecheck"
              label="Recheck.Temp :"
              className="text-lable"
            >
              <Input
                type="text"
                placeholder="Temperature"
                className="control-input"
              />
            </Form.Item>
          )}

          {/* Corrective Action - Mandatory when Van Condition is Decline */}
          {VanCondotion === "Decline" && (
            <Form.Item
              label="Corrective Action :"
              className="text-lable"
              rules={[
                {
                  required: VanCondotion === "Decline",
                  message: "Please select Corrective Action",
                },
              ]}
            >
              <div className="GoodsInward-Checkbox" style={{ display: 'flex', gap: '20px', paddingTop: '5px' }}>
                <Checkbox
                  checked={CorrectiveAction === "Accept"}
                  onChange={() => Set_CorrectiveAction("Accept")}
                >
                  Accept
                </Checkbox>
                <Checkbox
                  checked={CorrectiveAction === "Decline"}
                  onChange={() => Set_CorrectiveAction("Decline")}
                >
                  Decline
                </Checkbox>
              </div>
            </Form.Item>
          )}

          {/* Done by - Read Only */}
          <Form.Item
            label="Done by :"
            className="text-lable"
          >
            <Input
              type="text"
              disabled
              value={GoodInward?.createdBy || ""}
              className="control-input"
            />
          </Form.Item>

          {/* Hidden fields for Department and Product */}
          <div className="d-none">
            <DepartmentModel />
            
            <Form.Item
              name="productId"
              label="Product :"
              className="text-lable"
            >
              <Select className="control-Select mb-1" placeholder="Select Product">
                {Products && (
                  <>
                    {Products?.map((option, index) => (
                      <option key={index} value={option?.id}>
                        {option?.productName}
                      </option>
                    ))}
                  </>
                )}
              </Select>
            </Form.Item>
          </div>

          <div className="d-flex justify-content-center pt-4" style={{ gap: '15px' }}>
            <Button
              type="primary"
              htmlType="submit"
              className="btn btn-primary btn-save"
              style={{ width: "37%", height: "50px" }}
            >
              Update
            </Button>
            <Button
              type="default"
              className="btn btn-primary btn-back"
              style={{ width: "37%", height: "50px" }}
              onClick={onClose}
            >
              Cancel
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  );
}

export default EditGoodInward;